export const scopes = [
  'Xboxlive.signin',
  'Xboxlive.offline_access',
  'offline_access',
];
